import { Box, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IPortfolioItemChildFragment } from 'graphql/types';
import { TableCell } from 'common/components/Table';
import { PortfolioItemProgressScoreChip } from 'user/components/PortfolioItemProgressScoreChip';
import { Typography } from 'common/components/Typography';
import { formatDate } from 'common/utils/formatDate';
import { receivedCertificateEndDateNear } from 'common/utils/receivedCertificate';

interface IProps {
    item: IPortfolioItemChildFragment;
    onClick?(): void;
}

export const ReceivedCertificatePortfolioItemTableRow = ({
    item,
    ...other
}: IProps) => {
    const [translate] = useTranslation();

    const { endDate } = item;

    const isExpired = !!(!!endDate && new Date(endDate) < new Date());
    const isEndDateNear = !!endDate && receivedCertificateEndDateNear(endDate);

    const endDateDisplay = item.endDate
        ? formatDate(item.endDate, 'dd MMM yyyy')
        : null;

    return (
        <TableRow hover sx={{ cursor: 'pointer' }} {...other}>
            <TableCell>{item.title}</TableCell>

            <TableCell align="right">
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        justifyContent: 'flex-end',
                    }}
                >
                    {(isExpired || !!isEndDateNear) && (
                        <Typography
                            color={isExpired ? 'error' : 'grey.500'}
                            variant="body2"
                        >
                            {isExpired
                                ? endDateDisplay
                                : translate('receivedCertificateExpiryNear', {
                                      date: endDateDisplay,
                                  })}
                        </Typography>
                    )}

                    <PortfolioItemProgressScoreChip portfolioItem={item} />
                </Box>
            </TableCell>
        </TableRow>
    );
};
